import { PageEventsTypes } from "./events";

class AnalyticsManager {
  constructor() {
    if (AnalyticsManager.instance) {
      return AnalyticsManager.instance;
    }

    this._user = null;
    this.channels = [];
    AnalyticsManager.instance = this;
  }

  get user() {
    return this._user;
  }

  set user(value) {
    this._user = {
      id: value && value.id || "",
      role: value && value.role || "guest",
    };
  }

  registerChannel(channel) {
    if (channel && typeof channel.sendPageEvent === 'function' && typeof channel.sendPageView === 'function') {
      this.channels.push(channel);
    } else {
      console.error("Channel should have a 'sendPageEvent'/'sendPageView' method");
    }
  }

  isStandaloneMode() {
    return window.matchMedia('(display-mode: standalone)').matches ||
      'standalone' in window.navigator;
  }

  getUserUuidFromLocalStorage() {
    try {
      const userInfo = localStorage.getItem('userInfo');
      if (!userInfo) return null;

      const parsedUserInfo = JSON.parse(userInfo);
      if (!parsedUserInfo.id) return null;

      return parsedUserInfo.id;
    } catch (error) {
      return null;
    }
  }

  generateAdditionalInfo() {
    const userUuid = this.getUserUuidFromLocalStorage();

    return {
      country: this.isStandaloneMode() ? 'dinolab_pwa' : 'dinolab',
      url: window.location.href,
      userAgent: navigator.userAgent,
      userUuid,
    }
  }

  emitPageView() {
    this.channels.forEach((channel) => {
      channel.sendPageView({
        ...this.user,
        ...this.generateAdditionalInfo(),
      });
    });
  }

  emitPageEvent(action, payload) {
    if (!action) {
      console.error('Page event must have action!');
      return;
    }

    this.channels.forEach((channel) => {
      channel.sendPageEvent({
        action,
        payload: payload || {},
        ...this.user,
        ...this.generateAdditionalInfo(),
      });
    });
  }
}

const analyticsManager = new AnalyticsManager();

export { PageEventsTypes };
export default analyticsManager;
